import {Routes, Route, useLocation} from 'react-router-dom';
import Context from "./Context";
// import MarketNavbar from '../components/valtek-ec/MarketNavbar';
// import MarketTopbar from '../components/valtek-ec/MarketTopbar';

import HomePage from '../valtek-ec/HomePage';
// import ProductPage from '../app/valtek-ec/product/ProductPage';
// import CartPage from '../app/valtek-ec/cart/CartPage';
// import CheckoutPage from '../app/valtek-ec/checkout/CheckoutPage';


import ScrollTop from "../valtek-ec/components/ScrollTop";


import ScrollTopBehaviour from "../valtek-ec/components/ScrollTopBehaviour";
import Login from "../valtek-ec/modal/Login";
import SearchModal from "../valtek-ec/modal/SearchModal";
import CartComponent from "../valtek-ec/modal/CartComponent";
import ViewCartPage from "../valtek-ec/order/ViewCartPage";
import Quickview from "../valtek-ec/modal/Quickview";
import CheckoutPage from "../valtek-ec/page/CheckoutPage";
import CheckoutSuccessPage from "../valtek-ec/page/CheckoutSuccessPage";
import ProductDetailPage from "../valtek-ec/product/ProductDetailPage";
import SizeGuide from "../valtek-ec/modal/SizeGuide";
import NotFoundPage from "../valtek-ec/extra-pages/NotFoundPage";
import CartPage from "../valtek-ec/order/ViewCartPage";
import AboutUsPage from "../valtek-ec/extra-pages/AboutUsPage";
import ContactusPage from "../valtek-ec/extra-pages/ContactusPage";
import FaqPage from "../valtek-ec/extra-pages/FaqPage";
import PrivacyPolicyPage from "../valtek-ec/extra-pages/PrivacyPolicyPage";
import {useEffect, useState} from "react";
import AdminSpinner from "../valtek-ec/components/AdminSpinner";
import Toolbar from "../valtek-ec/components/Toolbar";
import DbSidebar from "../valtek-ec/modal/DbSidebar";
import MobileMenu from "../valtek-ec/modal/MobileMenu";
import UserProtectedRoute from "./UserProtectedRoute";
import AccountPage from "../valtek-ec/page/AccountPage";
import AccountOrderPage from "../valtek-ec/page/AccountOrderPage";
import AccountDetailsPage from "../valtek-ec/page/AccountDetailsPage";
import CategoryListPage from "../valtek-ec/page/CategoryListPage";
import ProductListPage from "../valtek-ec/page/ProductListPage";
import OrderDetails from "../valtek-ec/page/OrderDetails";
import Register from "../valtek-ec/modal/Register";
import ResetPass from "../valtek-ec/modal/ResetPass";
import ResetPassCode from "../valtek-ec/modal/ResetPassCode";
import NewPasswordModal from "../valtek-ec/modal/NewPasswordModal";
import {useIsFetching} from "@tanstack/react-query";
import RefundRequest from "../valtek-ec/modal/RefundRequest";
import ReturnRefundPage from "../valtek-ec/extra-pages/ReturnRefundPage";
import "photoswipe/dist/photoswipe.css";
import TermsAndConditions from "../valtek-ec/extra-pages/TermsAndConditions";
import VerifyEmailPage from "../valtek-ec/page/VerifyEmailPage";
import Cookie from "../valtek-ec/components/Cookie";

function ValtekEcLayout() {

    const [pageLoaded, setPageLoaded] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setPageLoaded(false); // Sayfa değiştiğinde yeniden yükleme başlasın
    }, [location.pathname]);


    return (
        <>




                <Context>
                    <Routes>
                        <Route path="/" element={<HomePage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="category-list" element={<CategoryListPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="product-list" element={<ProductListPage onPageReady={() => {setPageLoaded(true);}} />}/>
                        <Route path="product-detail/:slug" element={<ProductDetailPage onPageReady={() => {setPageLoaded(true);}}/>}/>

                        <Route path="view-cart" element={<CartPage onPageReady={() => {setPageLoaded(true);}}/>}/>

                        <Route path="account-page" element={<UserProtectedRoute element={<AccountPage onPageReady={() => {setPageLoaded(true);}}/>}/>}/>
                        <Route path="account-orders" element={<UserProtectedRoute element={<AccountOrderPage onPageReady={() => {setPageLoaded(true);}}/>}/>}/>
                        <Route path="account-details" element={<UserProtectedRoute element={<AccountDetailsPage onPageReady={() => {setPageLoaded(true);}}/>}/>}/>
                        <Route path="checkout" element={<UserProtectedRoute element={<CheckoutPage onPageReady={() => {setPageLoaded(true);}}/>}/>}/>
                        <Route path="checkout/success" element={<UserProtectedRoute element={<CheckoutSuccessPage onPageReady={() => {setPageLoaded(true);}}/>}/>}/>
                        {/*<Route path="cancel" element={<UserProtectedRoute element={<CheckoutCancelPage/>}/>}/>*/}
                        {/*<Route path="account-addresses" element={<UserProtectedRoute element={<AccountAddressPage/>}/>}/>*/}

                        <Route path="about-us" element={<AboutUsPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="contact-us" element={<ContactusPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="faq" element={<FaqPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="terms-and-conditions" element={<TermsAndConditions onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="return-and-refund" element={<ReturnRefundPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        {/*<Route path="cart-empty" element={<CartEmptyPage />} />*/}
                        <Route path="privacy-policy" element={<PrivacyPolicyPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="verify-email" element={<VerifyEmailPage onPageReady={() => {setPageLoaded(true);}}/>} />
                        <Route path="404" element={<NotFoundPage onPageReady={() => {setPageLoaded(true);}}/>}/>
                        <Route path="*" element={<NotFoundPage onPageReady={() => {setPageLoaded(true);}}/>}/>

                    </Routes>
                    <CartComponent/>
                    <Login/>
                    <Register/>
                    <ResetPass/>
                    <ResetPassCode/>
                    <NewPasswordModal/>
                    <Quickview/>
                    <OrderDetails/>
                    <SearchModal/>
                    <Toolbar/> <SizeGuide/><RefundRequest/>
                    {/*<QuestionModal/>*/}
                    {/*<ShareModal/>*/}
                    <MobileMenu/>
                    <DbSidebar/>
                </Context>

            {!pageLoaded && <AdminSpinner />}
                <ScrollTop/>
                <ScrollTopBehaviour/>
                <Cookie />

        </>
    );
}

const LoadingSpinner = ({children}) => {
    const [loading, setLoading] = useState(true); // İlk başta loading true olacak
    const location = useLocation();

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 1000); // Yükleme süresi simülasyonu
        return () => clearTimeout(timer);
    }, [location]);

    return (
        <div>
            {loading ? (
                <AdminSpinner/>
            ) : (
                children
            )}
        </div>
    );
};






export default ValtekEcLayout;
